import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const CareApprochNew: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.94473 32.4785L10.4416 28.132C11.3656 27.4013 12.5092 27.0039 13.6872 27.0039H26.6555C26.6787 27.0039 26.6974 27.0227 26.6974 27.0458C26.6974 29.2155 24.9385 30.9743 22.7689 30.9743H18.8082C17.7777 30.9743 16.9423 31.8097 16.9423 32.8402C16.9423 33.8707 17.7777 34.7061 18.8082 34.7061H31.0185L40.042 28.0919C40.8981 27.4644 42.0827 27.5494 42.8404 28.2927C43.7273 29.1628 43.7025 30.5989 42.786 31.4378L34.4181 39.0977C32.6735 40.6947 30.394 41.5804 28.0289 41.5804H5.66633C5.02383 41.5804 4.50293 41.0595 4.50293 40.417V33.3909C4.50293 33.0353 4.66563 32.6991 4.94473 32.4785Z"
      fill="#FF612B"
    />
    <path
      d="M31.4396 12.4968H34.4587V16.3488H31.4396V19.5761H27.5876V16.3488H24.3603V12.4968H27.5876V9.26939H31.4396V12.4968ZM29.5136 22.4911C33.9696 22.4911 37.5819 18.8788 37.5819 14.4228C37.5819 9.96679 33.9696 6.35449 29.5136 6.35449C25.0576 6.35449 21.4453 9.96679 21.4453 14.4228C21.4453 18.8788 25.0576 22.4911 29.5136 22.4911Z"
      fill="#002677"
    />
    <path
      d="M31.4397 12.4969H34.4588V16.3489H31.4397V19.5762H27.5877V16.3489H24.3604V12.4969H27.5877V9.26953H31.4397V12.4969Z"
      fill="white"
    />
  </Box>
)

export default CareApprochNew
